import React from 'react';
import { Grid, GridItem, useDisclosure } from '@chakra-ui/react';
import Sidebar from '../Sidebar';
import MainLayout from './index';
import { RenderIf } from '../RenderIf/RenderIf';
import SubNavWrapper from '../SubNav/SubNavWrapper';
const MainLayoutSidebar = (props) => {
    const { selected, sidebarSection, children, ...rest } = props;
    const shouldShowSidebar = sidebarSection !== null;
    const { isOpen: isSidebarToggled, onToggle: onSidebarToggled } = useDisclosure({ defaultIsOpen: true });
    return (React.createElement(MainLayout, { centerContentAdditionalClasses: "main-layout__content--upgrade", showAlerts: false, ...rest },
        React.createElement(Grid, { templateAreas: `"nav main"`, gridTemplateRows: "0px 1fr", gridTemplateColumns: "auto minmax(0, 1fr)" },
            React.createElement(RenderIf, { condition: !props.shouldHideSidebar },
                React.createElement(GridItem, { area: "nav", mr: "68px", "aria-label": "Main navigation", role: "navigation" },
                    React.createElement(Sidebar, { selected: selected, isSidebarToggled: isSidebarToggled, onSidebarToggled: onSidebarToggled, showToggle: shouldShowSidebar })),
                React.createElement(RenderIf, { condition: isSidebarToggled },
                    React.createElement(SubNavWrapper, { sidebarSection: sidebarSection }))),
            React.createElement(GridItem, { area: "main", minH: "100vh" }, children))));
};
export default MainLayoutSidebar;
